export const LIMITED_ROLE = 'limited';
export const ACTIVE_ROLE = 'active';
export const KORTA_ROLE = 'korta';
export const KORTA_RAPYD_ROLE = 'korta_rapyd';
export const ACTIVE_WITH_VIRTUAL_TERMINAL = 'active_with_virtual_terminal';
export const VALITOR_ROLE = 'valitor';
export const VALITOR_ECOM_ROLE = 'valitor_ecom';
export const RAPYD_LEAN_ROLE = 'rapyd_lean';
export const RBA_HK_ROLE = 'rba_hk';

export const NOT_RAPYD_ROLES = [
  KORTA_ROLE,
  KORTA_RAPYD_ROLE,
  VALITOR_ROLE,
  VALITOR_ECOM_ROLE,
  RAPYD_LEAN_ROLE,
];
